import React from 'react';

import {Button, MenuItem} from '@blueprintjs/core';
import {MultiSelect2} from '@blueprintjs/select';


export default function GenerationOutagesMultiSelect({type_name, items, selectedItems, dispatch, disabled}) {

    const LocalOutagesMultiSelect = MultiSelect2.ofType();

    const itemRenderer = (item, {handleClick, modifiers}) => {
        return (
            <MenuItem
                active={modifiers.active}
                icon={isSelected(item) ? 'tick' : 'blank'}
                key={item}
                // label={item}
                disabled={modifiers.disabled}
                onClick={handleClick}
                text={item}
            />
        );
    };

    const renderTag = (item) => {
        return `${item}`;
    };

    const isSelected = (item) => {
        return selectedItems.includes(item);
    };

    const selectItem = (item) => {
        const selected = [...selectedItems, item];
        dispatch({type: type_name, selection: selected, added: item});
    };

    const deselect = (item) => {
        const selected = selectedItems.filter(d => d !== item);
        dispatch({type: type_name, selection: selected, removed: item});
    };

    const handleSelect = (item) => {
        if (!isSelected(item)) {
            selectItem(item);
        } else {
            deselect(item);
        }
    };

    const handleTagRemove = (item, index) => {
        deselect(item);
    };

    const handleClear = () => dispatch({type: type_name, selection: []});
    const clearButton = items.length > 0 && !disabled ? <Button icon='cross' minimal={true} onClick={handleClear}/> : undefined;

    return (
        <LocalOutagesMultiSelect
            items={items}
            itemRenderer={itemRenderer}
            onItemSelect={handleSelect}
            onRemove={handleTagRemove}
            popoverProps={{minimal: true}}
            tagRenderer={renderTag}
            tagInputProps={{
                rightElement: clearButton,
            }}
            selectedItems={selectedItems}
            disabled={disabled}
        />
    );

}